import { render, staticRenderFns } from "./PlanesAndTrainsEmissionFactors.vue?vue&type=template&id=00085f5b&scoped=true"
import script from "./PlanesAndTrainsEmissionFactors.vue?vue&type=script&lang=js"
export * from "./PlanesAndTrainsEmissionFactors.vue?vue&type=script&lang=js"
import style0 from "./PlanesAndTrainsEmissionFactors.vue?vue&type=style&index=0&id=00085f5b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00085f5b",
  null
  
)

export default component.exports